function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
//import { Events } from '../infrastructure/const';

var EventBus = window.DGS.Event.getInstance();

/**
 * @memberOf module:wdh-feature-b2b
 */
var RadioList = /*#__PURE__*/function (_React$Component) {
  function RadioList(props) {
    var _this;
    _classCallCheck(this, RadioList);
    _this = _callSuper(this, RadioList, [props]);
    _this.state = {
      selectedValue: _this.props.selectedValue,
      hasError: _this.props.hasError,
      display: _this.props.display
    };
    if (_this.props.reverse) {
      _this.props.items.reverse();
    }
    return _this;
  }
  _inherits(RadioList, _React$Component);
  return _createClass(RadioList, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        selectedValue: this.props.selectedValue
      });
      /*
      EventBus.on(Events.FORCE_ASSIGNMENTS_CANCELED, () => {
          if (this.props.selectedValue !== this.state.selectedValue) {
              this.setState({ selectedValue: this.props.selectedValue });
          }
      });
       */
    }

    /**
     * The component properties were received and component state will be synced with the change
     * @param {Object} nextProps The updated properties of the component
     */
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.display !== this.props.display) {
        this.setState({
          display: nextProps.display
        });
      }
      if (nextProps.hasError !== this.props.hasError) {
        this.setState({
          hasError: nextProps.hasError
        });
      }
      if (nextProps.selectedValue !== this.props.selectedValue) {
        this.setState({
          selectedValue: nextProps.selectedValue
        });
      }
    }
  }, {
    key: "onRadioChange",
    value: function onRadioChange(e) {
      this.setState({
        selectedValue: e.currentTarget.value
      });
      this.props.onValueChange(e);
    }
  }, {
    key: "onRadioClick",
    value: function onRadioClick(e) {
      if (this.props.unselectEnabled && e.currentTarget.value === this.state.selectedValue) {
        e.currentTarget.value = null;
        this.setState({
          selectedValue: null
        });
        this.props.onValueChange(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var divWrapperClasses = classNames({
        'wdh-feature-b2b-field': true,
        'form-field': true,
        'radio-input': true,
        'has-error': this.state.hasError
      });
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id,
        className: divWrapperClasses,
        style: {
          display: this.state.display ? 'inline-block' : 'none'
        }
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: this.props.id,
        style: {
          display: this.props.label !== '' ? 'inline-block' : 'none'
        }
      }, this.props.label, this.props.isRequired && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement("div", {
        className: "package-radio-list"
      }, this.props.items.map(function (option) {
        return /*#__PURE__*/React.createElement("div", {
          key: "radioItem_".concat(option.value),
          className: classNames({
            'radio-forceable': option.forceable,
            vertical: _this2.props.arrangeVertically
          })
        }, /*#__PURE__*/React.createElement("input", {
          id: "".concat(_this2.props.id, "-item-").concat(option.value),
          type: "radio",
          name: "".concat(_this2.props.id, "-item-").concat(option.value),
          checked: _this2.state.selectedValue === option.value,
          value: option.value,
          onChange: function onChange(event) {
            return _this2.onRadioChange(event);
          },
          onClick: function onClick(event) {
            return _this2.onRadioClick(event);
          }
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "".concat(_this2.props.id, "-item-").concat(option.value),
          className: _this2.props.boldSelectedOption && _this2.state.selectedValue === option.value ? 'option-selected-bold' : ''
        }, option.text, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "\xA0"))));
      })));
    }
  }], [{
    key: "randomString",
    value:
    /**
     * Generate a random string
     * @param {Number} length Length of the random string
     */
    function randomString(length) {
      var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      var string = '';
      for (var r = 0; r < length; r += 1) {
        string += letters.charAt(Math.floor(Math.random() * letters.length));
      }
      return string;
    }
  }]);
}(React.Component);
RadioList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.bool.isRequired]),
    text: PropTypes.string.isRequired,
    forceable: PropTypes.bool
  })).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onValueChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  display: PropTypes.bool,
  showHelpText: PropTypes.bool,
  helpTextHTML: PropTypes.string,
  hasError: PropTypes.bool,
  isRequired: PropTypes.bool,
  reverse: PropTypes.bool,
  unselectEnabled: PropTypes.bool,
  boldSelectedOption: PropTypes.bool,
  arrangeVertically: PropTypes.bool
};
RadioList.defaultProps = {
  id: "radio-list-".concat(RadioList.randomString(4)),
  display: true,
  showHelpText: false,
  helpTextHTML: '&nbsp;',
  hasError: false,
  selectedValue: '',
  onValueChange: function onValueChange() {},
  isRequired: false,
  reverse: false,
  unselectEnabled: false,
  boldSelectedOption: false,
  arrangeVertically: false
};
export default RadioList;